import { isReactNativeWebView } from "@/utils/useWebViewBridge";

/**
 * No app / viewport estreito: usa ScreenMobile + abertura da URL do dispensador
 * (popup ou top-level), em vez do popup “solto” do desktop.
 */
export function shouldUseEmbeddedMarketplacePayment(): boolean {
  if (typeof window === "undefined") return false;
  if (isReactNativeWebView()) return true;
  return window.matchMedia("(max-width: 899px)").matches;
}
